import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { practitionerStyles as styles } from './styles';

class CalendarHeaderRoom extends React.Component {
    render() {
        const { classes, schedule } = this.props;

        return (
            <div className={classes.staff}>
                <Typography variant="button">{schedule.room && schedule.room.name}</Typography>
                <b style={{ fontSize: 10 }}>{schedule.room && schedule.allocatedTime.toFixed()}%</b>
            </div>
        );
    }
}

CalendarHeaderRoom.propTypes = {
    classes: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired
};

export default withStyles(styles)(CalendarHeaderRoom);
